// extracted by mini-css-extract-plugin
module.exports = {"get-order-detail":"get-order-detail-92cb4f4dbeebc5e1706d91334782a3ef"};